import styled, { css, keyframes } from "styled-components";

const fadeInAnim = keyframes`
  0%{
     transform: translateY(75px);
     opacity:0
  }
  10%{
    transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
    transform: translateY(75px);
    opacity:0
  }
  50%{
    transition-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
    transform:translateY(-10px);
    opacity:0.5;
  }
  100%{
    transform:translateY(0px)
    opacity:1
   } 
`;

const fadeOutAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
     transform: translateY(0);
     opacity:1;
    }
    100%{
      transform:translateY(123px);
      opacity:0;
   } 
`;

const fadeIn = css`
  ${fadeInAnim} 0.55s 1 forwards
`;
const fadeOut = css`
  ${fadeOutAnim} 0.55s 1 forwards
`;
const scaleDown = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
     transform: scale(1);
     filter: blur(0);
     }
    100%{
      transform: scale(.9);
      filter: blur(15px);
    } 
`;
export const HistoryDiv = styled.div`
  animation: ${fadeIn};
  animation: ${(p) => (p.unBlur ? fadeOut : null)};
  animation: ${(p) =>
    p.scaleDown
      ? css`
          ${scaleDown} 0.55s 1 forwards
        `
      : null};

  color: #ffb000;
  position: absolute;
  left: 0;
  right: 0;
  height: 200%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #32075b;

  color: #7f3da5;
  -ms-overflow-style: none; // IE 10+
  scrollbar-width: none; // Firefox
  &::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }
  & > div {
    height: 667px;
    width: 375px;
  }
  & > div > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 315px;
    height: 607px;
  }
`;
export const Header = styled.div`
  display: grid;
  grid-template-columns: 25.4% 25.4% 25.4% 36px;
  grid-column-gap: 13px;
  align-items: center;
  padding: 0 0 30px;
  /* temp max-width */
  max-width: 320px;
  margin: auto;

  svg {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    padding: 6px;
    border: solid 3px #7f3da5;
    cursor: pointer;
  }
`;
export const Tab = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 18px;
  border: solid 3px #7f3da5;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  animation: ${(p) => (p.active ? css`tab 50ms forwards 1 linear` : null)};

  .inner {
    position: absolute;
    top: -1px;
    left: -1px;
    height: 105%;
    width: 104%;
    background: #7f3da5;
    border-radius: 18px;
    opacity: 0;
    animation: ${(p) => (p.active ? css`inner 167ms forwards 1 linear` : null)};
  }
  p {
    z-index: 1;
  }
  @keyframes inner {
    0% {
      transform: scale(0.5);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  @keyframes tab {
    0% {
      border-width: 3px;
      color: #7f3da5;
    }
    100% {
      border-width: 0px;
      color: #32075b;
    }
  }
`;

export const Thead = styled.div`
  font-size: 10px;
  display: grid;
  grid-template-columns: 30% 25% 45%;
  line-height: 2.5;
  /* temp max-width */
  max-width: 320px;
  margin: auto;
  text-align: left;
`;
export const TBody = styled.div`
  /* temp max-width */
  max-width: 320px;
  margin: auto;
`;
export const TRow = styled.div`
  font-size: 12px;
  display: grid;
  grid-template-columns: 30% 25% 45%;
  line-height: 2.5;
  cursor: ${(p) => (p.pointer ? "pointer" : "auto")};
  :first-child {
    animation: rowAnimationM 0.3s linear forwards;
    -moz-animation: rowAnimationM 0.3s linear forwards;
  }
  :nth-child(19) {
    opacity: 0;
    transition: 0.3s;
  }

  @keyframes rowAnimationM {
    0% {
      height: 0px;
      line-height: 0px;
    }
    100% {
      line-height: 25px;
      height: 25px;
    }
  }
  @keyframes rowAnimationD {
    0% {
      line-height: 0px;
      height: 0px;
    }
    100% {
      height: 33px;
      line-height: 33px;
    }
  }
  @-moz-keyframes rowAnimationM {
    0% {
      height: 0px;
      line-height: 0px;
    }
    100% {
      line-height: 25px;
      height: 25px;
    }
  }
  @-moz-keyframes rowAnimationD {
    0% {
      line-height: 0px;
      height: 0px;
    }
    100% {
      height: 33px;
      line-height: 33px;
    }
  }
`;
export const ProfitBox = styled.div`
display: flex;
justify-content: flex-end;
  /* display: grid;
  grid-template-columns: 100% 12% auto; */
  max-width: 200px;
  svg {
    path {
      fill: #ae51e4;
    }
  }
`;
